<template>
  <aw-select
    :options="$controls[id].items"
    :multiple="multiple"
    v-model="selectVal"
    class="tokenize form-select"
  >
    <template v-slot:items="{ option, removeOption }">
      <div
        class="tokenize-item"
      >
        <span class="ml-2 mr-1 px-1">{{
          option.label
        }}</span>
        <button
          class="d-inline-block"
          @click.prevent.stop="removeOption(option)"
          tabindex="-1"
          title="Remove"
        >
          
        </button>
      </div>
    </template>
    <template
      v-slot:option="{
        option,
        highlighted,
        selected,
        handleMouseEnter,
        selectOption
      }"
    >
      <li
        role="option"
        class="cursor-default select-none relative py-2 pl-8 pr-4 truncate"
        :class="{
          'text-white bg-indigo-600': highlighted,
          'text-gray-900': !highlighted
        }"
        @mouseenter="handleMouseEnter(option)"
        @click.stop="selectOption(option)"
      >
        <span
          class="font-normal block truncate"
          :class="{ 'font-semibold': selected, 'font-normat': !selected }"
        >
          {{ option.label }}
        </span>
        <span
          class="absolute inset-y-0 left-0 flex items-center pl-1.5"
          :class="{
            'text-white': highlighted,
            'text-indigo-600': !highlighted
          }"
          v-show="selected"
        >
          <!-- Heroicon name: check -->
          <svg
            class="h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"
            />
          </svg>
        </span>
      </li>
    </template>
    <template v-slot:noresults>
      <li
        role="option"
        class="py-2 pl-8 pr-4 not-found"
      >
        <span class="font-semibold block text-red-400">
          Žádný výsledek nenalezen, změnte hledaný výraz
        </span>
        <span class="">
          <aw-icon icon="emoji-frown" class="h-5 w-5 text-red-400" />
        </span>
      </li>
    </template>
    <template v-slot:maxresults="{ maxOptions, filteredOptions }">
      <li
        role="option"
        class="py-2 pl-8 pr-4"
      >
        <span class="font-semibold block text-blue-400">
          Zobrazeno prvních {{ maxOptions }} záznamů z
          {{ filteredOptions.length }}. Upřesněte hledaný výraz
        </span>
        <span class="absolute inset-y-0 left-0 flex items-center pl-1.5">
          <aw-icon icon="exclamation-circle" class="h-5 w-5 text-blue-400" />
        </span>
      </li>
    </template>
  </aw-select>

  <select
    :name="name"
    v-model="selectVal"
    v-bind="$attrs"
    class="nod"
    ref="select"
    multiple
  >
    <option
      v-for="item in $controls[id].items"
      :key="item.id"
      :value="item.id"
      >{{ item.label }}</option
    >
  </select>

  <div
    class="invalid-feedback"
    v-if="$controls[id].hasErrors"
    :id="id + '_message'"
  >
    <div v-for="(error, index) in $controls[id].getErrors" :key="index">
      {{ error }}
    </div>
  </div>
</template>
<script>
// import AwSelect from '../../../../nette-base-module/js/components/AwSelect.vue'
// import InputMixin from '../../mixins/input'
import isEqual from "lodash/isEqual";

export default {
  props: {
    multiple: {
      default: true,
      type: Boolean
    },
    name: String,
    id: String
  },
  data() {
    return {};
  },
  computed: {
    selectVal: {
      get() {
        return this.$controls[this.id].val;
      },
      set(val) {
        //if (this.timeout) clearTimeout(this.timeout);
        //this.timeout = setTimeout(() => {
          // console.log('dsafsdf fdsfa aff adsa', this.$refs.select)
          if (!isEqual(this.$controls[this.id].val, val)) {
            setTimeout(() => {
              this.$refs.select.dispatchEvent(
                new Event("change", { bubbles: true })
              );
            }, 50);
          }
          this.$store.dispatch("nette/updateControl", {
            controlName: this.id,
            data: val,
            key: "val"
          });
        //}, 300);
      }
    }
  }
};
</script>
